import YellowSideProp from "../../assets/svg/YellowSideProp";
import Rectangle from "../../assets/images/rectangle.png";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  Box,
  Container,
  Content,
  Heading,
  HeadingWrapper,
  ImageContainer,
  LeftView,
  LowerContent,
  MainWrapper,
  NumberBox,
  RightView,
  NewSlider,
  SliderContent,
  SliderHeading,
  SvgWrapper,
  TextBox,
  TextContainer,
  TextWrapper,
  UpperContent,
  UpperSvgWrapper,
  Wrapper,
  LowerContentLi,
} from "../../styles/views/Achievements";
import Lines from "../../assets/svg/lines";
import Background from "../../assets/svg/background";
import UpperBackground from "../../assets/svg/upperBackground";
import { styled } from "styled-components";

const Achievements = () => {
  const SliderWrap = styled(Slider)`
    width: 100%;
    max-width: 1200px;
  `;

  const data = [
    {
      heading: "Foreign Expats Recruitment",
      upperText:
        "If you're looking to scale your business with a skilled, compliant, and reliable foreign workforce, Hire Hub Solutions is here to help. Our team is ready to discuss your specific needs and offer tailored staffing solutions to drive your business forward.",
      lowerText: "Get in touch with us today to learn more about how we can assist with your staffing needs.",
    },
    {
      heading: "Contract Staffing Solutions",
      upperText:
        "Whether you need workers for a few months or several years, we provide flexible staffing solutions based on your project timelines.",
      lowerText:
        "We handle all the paperwork and legal requirements, including work visas and employment contracts, to ensure smooth operations.",
    },
    {
      heading: "End-to-End Workforce Management",
      upperText:
        "From the recruitment process to the ongoing management of foreign expatriates, we take care of everything.",
      lowerText: "We provide on-ground support to assist with on boarding, training, and integration into your team.",
    },
    {
      heading: "Specialized Labour Pools",
      upperText:
        "We focus on sourcing manpower for a wide variety of industries including civil, excavation (mining), Infrastructure, manufacturing, hospitality, healthcare, and more.",
      lowerText:
        "Whether you need technicians, engineers, healthcare professionals, or manual labours, we have a network of experts ready to assist.",
    },
    {
      heading: "Compliance & Regulatory Assistance",
      upperText:
        "Navigating labour laws and immigration regulations can be complex. Our team ensures compliance with all relevant regulations, including visas, work permits, and labour laws in both the home country and your host country.",
      lowerText: "",
    },
    {
      heading: "On Demand Workforce Flexibility",
      upperText:
        "We offer scalable staffing solutions that adapt to your changing business needs. Whether you have fluctuating demand or seasonal peaks, we ensure you always have the right people in place.",
      lowerText: "",
    },
    {
      heading: "Embassy assistance",
      upperText:
        "We provide immigration support work for making visas to ensure that immigration laws are followed and help individuals successfully to relocate abroad.",
      lowerText: `Business Visa, Study Visa, Tourist/Visitor Visa, Employment Visa, Dependent Sponsorship for obtaining visa.
Document preparation along with guideline and support.
Resident permit in India including Police/SP office verification Services.
Police verification of the respective country.
Provident fund assistance.
Taxation Services.`,
    },
    {
      heading: "Safety, Health, and Environmental Management Policy",
      upperText:
        "At Hire Hub Solutions, we prioritize worker safety, health, and environmental responsibility. We provide safety training, health resources, and monitor compliance with local regulations. We collaborate with clients to promote eco-friendly practices and sustainable workplaces. Our commitment ensures a safe, ethical, and productive environment for all workers.",
      lowerText: "",
    },
  ];

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <Container>
      <LeftView>
        <YellowSideProp />
      </LeftView>
      <MainWrapper>
        {/* <Wrapper>
          <Box>
            <NumberBox>834.0 K</NumberBox>
            <TextBox>Total Freelancer</TextBox>
          </Box>
          <Box>
            <NumberBox>732.0 K</NumberBox>
            <TextBox>Positive Review</TextBox>
          </Box>
          <Box>
            <NumberBox>90.0 K</NumberBox>
            <TextBox>Order Received</TextBox>
          </Box>
          <Box>
            <NumberBox>236.0 K</NumberBox>
            <TextBox>Project Complete</TextBox>
          </Box>
        </Wrapper> */}
        <Heading>
          <TextWrapper>/ our services /</TextWrapper>
          <HeadingWrapper>Connecting Talent, Supporting Projects</HeadingWrapper>
        </Heading>
        <SliderWrap {...settings}>
          {data?.map((item, index) => {
            return (
              <NewSlider key={index}>
                <ImageContainer>
                  <img alt="no-image" src={Rectangle} />
                </ImageContainer>
                <Content>
                  <UpperSvgWrapper>
                    <UpperBackground />
                  </UpperSvgWrapper>
                  <TextContainer>
                    <SliderHeading>{item.heading}</SliderHeading>
                    <SliderContent>
                      <UpperContent>{item?.upperText}</UpperContent>
                      {item.lowerText.includes("\n") ? (
                        <ul>
                          {item.lowerText.split("\n").map((line, idx) => (
                            <LowerContentLi key={idx}>{line.trim()}</LowerContentLi>
                          ))}
                        </ul>
                      ) : (
                        <LowerContent>{item.lowerText}</LowerContent>
                      )}
                    </SliderContent>
                  </TextContainer>
                  <SvgWrapper>
                    <Background />
                  </SvgWrapper>
                </Content>
              </NewSlider>
            );
          })}
        </SliderWrap>
      </MainWrapper>
      <RightView>
        <Lines />
      </RightView>
    </Container>
  );
};

export default Achievements;
